import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./partial/Header";
import Sidebar from "./partial/Sidebar";
import JoditEditor from "jodit-react";
import { useAllPackageTypeQuery } from "../../redux/API/PackageTypeApi";
import {
  useGetPackageDetailsQuery,
  useUpdatePackageMutation,
} from "../../redux/API/PackageApi";

import ChangePassword from "./partial/ChangePassword";
import toast, { Toaster } from "react-hot-toast";
import { ImgUrl, packageImgUrl } from "../Constant";


const UpdatePackage = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const overviewEditor = useRef(null);
  const inclusionEditor = useRef(null);
  const exclusionEditor = useRef(null);
  const itineraryEditor = useRef(null);
  const { slug } = useParams();
  const { data: packageDetail, refetch } = useGetPackageDetailsQuery(slug);
  const { data: packageType } = useAllPackageTypeQuery();
  const {
    name,
    ptypeId,
    location,
    days,
    persons,
    price,
    overview,
    inclusion,
    exclusion,
    itinerary,
  } = packageDetail?.data || {
    name: "",
    ptypeId: "",
    location: "",
    days: "",
    persons: "",
    price: "",
    updatedOverview: "",
    updatedinclusion: "",
    updatedExclusion: "",
    updatedItinerary: "",
  };
  const [updatedName, setUpdatedName] = useState(name);
  const [updatedPtypeId, setUpdatedPtypeId] = useState(ptypeId);
  const [updatedLocation, setUpdatedLocation] = useState(location);
  const [updatedDays, setUpdatedDays] = useState(days);
  const [updatedPerson, setUpdatedPerson] = useState(persons);
  const [updatedPrice, setUpdatedPrice] = useState(price);
  const [updatedOverview, setUpdatedOverView] = useState(overview);
  const [updatedinclusion, setUpdatedInclusion] = useState(inclusion);
  const [updatedExclusion, setUpdatedExclusion] = useState(exclusion);
  const [updatedItinerary, setUpdatedItinerary] = useState(itinerary);
  const [image, setImage] = useState([]);
  const fileInputRef = useRef(null); 

  useEffect(() => {
    if (packageDetail) {
      setUpdatedName(packageDetail?.data.name);
      setUpdatedPtypeId(packageDetail?.data?.ptypeId?._id);
      setUpdatedLocation(packageDetail?.data?.location);
      setUpdatedDays(packageDetail?.data?.days);
      setUpdatedPerson(packageDetail?.data?.persons);
      setUpdatedPrice(packageDetail?.data?.price);
      setUpdatedExclusion(packageDetail?.data?.exclusion);
      setUpdatedItinerary(packageDetail?.data?.itinerary);
      setUpdatedOverView(packageDetail?.data?.overview);
      setUpdatedInclusion(packageDetail?.data?.inclusion);
    }
    refetch();
  }, [packageDetail, refetch]);

  const [postData] = useUpdatePackageMutation(slug);
  const navigate = useNavigate();
  
  
  const handleImage = (e) => {
    const files = Array.from(e.target.files || []);
    const sizeLimit = 2 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
  
    const resetInput = () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        e.target.type = '';
        e.target.type = 'file';
      }
    };
  
    const invalidFiles = files.filter(file => {
      const ext = file.name.split('.').pop().toLowerCase();
      const isValidType = allowedTypes.includes(file.type);
      const isValidExtension = allowedExtensions.includes(ext);
      return !(isValidType && isValidExtension);
    });
  
    if (invalidFiles.length > 0) {
      toast.error("Invalid file format. Only JPG, JPEG, PNG, WEBP are allowed.");
      resetInput();
      return;
    }
  
    let isAnyInvalid = false;
  
    files.forEach((file) => {
      if (file.size > sizeLimit) {
        toast.error("File size should be less than 2MB");
        isAnyInvalid = true;
        resetInput();
        return;
      }
  
      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.src = objectUrl;
  
      img.onload = () => {
        if (img.width === 1500 && img.height === 400) {
          setImage((prev) => [...prev, { file }]);
        } else {
          toast.error("Image dimensions should be 1500x400 pixels");
          isAnyInvalid = true;
          resetInput();
        }
        URL.revokeObjectURL(objectUrl);
      };
  
      img.onerror = () => {
        toast.error("Invalid image file.");
        isAnyInvalid = true;
        resetInput();
        URL.revokeObjectURL(objectUrl);
      };
    });
  };
  
  // Handle Form Submit
  const handleCreatePackage = (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    image.forEach((img) => {
      formData.append("images", img.file);
    });
    formData.append("name", updatedName);
    formData.append("ptypeId", updatedPtypeId);
    formData.append("location", updatedLocation);
    formData.append("days", updatedDays);
    formData.append("persons", updatedPerson);
    formData.append("price", updatedPrice);
    formData.append("overview", updatedOverview);
    formData.append("inclusion", updatedinclusion);
    formData.append("exclusion", updatedExclusion);
    formData.append("itinerary", updatedItinerary);
  
    postData({ slug: slug, data: formData })
      .then((res) => {
        if (res.data?.success) {
          navigate("/admin/packages");
        } else {
          toast.error(res?.error?.data?.message || "Something went wrong, Please try later.");
        }
      })
      .catch((err) => {
        const message =
          err.response?.data?.message || "An unexpected error occurred. Please try again.";
        toast.error(message);
      });
  };
  
  const handleToggle = () => {
    if (newClass === "") {
      setNewClass("main-active");
    } else {
      setNewClass("");
    }
    if (newSidebarClass === "") {
      setNewSidebarClass("closed");
    } else {
      setNewSidebarClass("");
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} setShowPass={setShowPass} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Update Package
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/packages" className="btn btn-primary rounded-2">
              Back <FaArrowLeft />
            </Link>
          </div>
          <div className="container card p-4">
            <form className="row gy-3" onSubmit={handleCreatePackage}>
              <div className="col-lg-6">
                <label htmlFor="name">Package Name </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter Package Type"
                  value={updatedName}
                  onChange={(e) => setUpdatedName(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="ptypeId">Package Type </label>
                <select
                  name="ptypeId"
                  id="ptypeId"
                  className="form-control"
                  value={updatedPtypeId}
                  onChange={(e) => setUpdatedPtypeId(e.target.value)}
                >
                  <option value="">Select Package Type</option>
                  {packageType &&
                    packageType?.data?.map((pkg) => (
                      <option value={pkg._id} key={pkg._id}>
                        {pkg.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-lg-6">
                <label htmlFor="location">Location </label>
                <input
                  type="text"
                  className="form-control"
                  id="location"
                  name="location"
                  placeholder="Enter Location"
                  value={updatedLocation}
                  onChange={(e) => setUpdatedLocation(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="days">Days </label>
                <input
                  type="text"
                  className="form-control"
                  id="days"
                  name="days"
                  placeholder="Enter Days"
                  value={updatedDays}
                  onChange={(e) => setUpdatedDays(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="persons">Person </label>
                <input
                  type="text"
                  className="form-control"
                  id="persons"
                  name="persons"
                  placeholder="Enter Number of Person"
                  value={updatedPerson}
                  onChange={(e) => setUpdatedPerson(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="price">Price </label>
                <input
                  type="text"
                  className="form-control"
                  id="price"
                  name="price"
                  placeholder="Enter Price"
                  value={updatedPrice}
                  onChange={(e) => setUpdatedPrice(e.target.value)}
                />
              </div>

              <div className="col-lg-6">
                <label htmlFor="price">Image </label>
                <input
                  type="file"
                  multiple
                  className="form-control"
                  id="image"
                  name="image"
                  onChange={handleImage}
                  ref={fileInputRef}
                />
              </div>
              <div className="col-lg-6">
                <div className="row">
                  {packageDetail?.data?.images?.map((i) => {
                    return (
                      <div className="col-2">
                      <img src={`${ImgUrl}${packageImgUrl}${i}`} alt="" width={80} />
                    </div>
                    )
})}
                </div>
              </div>
              <div className="col-lg-6">
                <label htmlFor="name">Overview </label>
                <JoditEditor
                  ref={overviewEditor}
                  value={updatedOverview}
                  onChange={(newContent) => setUpdatedOverView(newContent)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="name">Inclusion </label>
                <JoditEditor
                  ref={inclusionEditor}
                  value={updatedinclusion}
                  onChange={(newContent) => setUpdatedInclusion(newContent)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="name">Exclusion </label>
                <JoditEditor
                  ref={exclusionEditor}
                  value={updatedExclusion}
                  onChange={(newContent) => setUpdatedExclusion(newContent)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="name">Itinerary </label>
                <JoditEditor
                  ref={itineraryEditor}
                  value={updatedItinerary}
                  onChange={(newContent) => setUpdatedItinerary(newContent)}
                />
              </div>
              <div className="col-lg-6 pt-4">
                <button
                  className="btn btn-primary px-4 rounded-2"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default UpdatePackage;
